import { FC } from 'react';
import { FilterFormRowProps } from './filterFormRow.types';

const FilterFormRow: FC<FilterFormRowProps> = (props) => {
  return (
    <div className="flex mt-4 items-start">
      <div className="w-[30%] pt-2 text-sm text-[#1A1A1A] leading-[20px] min-h-[40px]">
        {props.label}
      </div>
      <div className="w-[70%] min-h-[40px]">{props.children}</div>
    </div>
  );
};

export default FilterFormRow;
